import './index.css';
import App from './App';
import React from 'react';
import ReactDOM from 'react-dom/client';
import ChatbotWidget from './components/ChatbotWidget';
import reportWebVitals from './reportWebVitals';

window.renderChatbotWidget = (containerId) => {
     ReactDOM.render(<ChatbotWidget />, document.getElementById(containerId));
   }


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
